import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "./basequery";
import { createSelector } from "@reduxjs/toolkit";

export const labelCraftServiceApi = createApi({
  reducerPath: "labelCraftServicef",
  tagTypes: ["ImageDatasets"],
  baseQuery: baseQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getImagesDataset: builder.query({
      query: ({ project_id, page }) => ({
        url: `/label/image/`,
        params: { project_id, page },
      }),
      providesTags: (data) =>
        data?.data
          ? [
              ...data?.data?.map?.(({ id }) => ({ type: "ImageDatasets", id })),
              { type: "ImageDatasets", id: "LIST" },
            ]
          : [{ type: "ImageDatasets", id: "LIST" }],
    }),
    getTrainingModels: builder.query({
      query: (project_id) => ({
        url: `/engine/compiling/${project_id}/labelcraft/`,
      }),
      // providesTags: (data) =>
      //   data?.data
      //     ? [
      //         ...data?.data?.map?.(({ id }) => ({ type: "ImageDatasets", id })),
      //         { type: "ImageDatasets", id: "LIST" },
      //       ]
      //     : [{ type: "ImageDatasets", id: "LIST" }],
    }),

    getImageDataset: builder.query({
      query: ({ project_id, images }) => ({
        url: `/label/image/`,
        params: { project_id, images },
      }),
    }),

    createImagesDataset: builder.mutation({
      query: ({ project_id, images }) => ({
        url: `/label/image/`,
        method: "post",
        data: { project_id, images },
      }),
      invalidatesTags: [{ type: "ImageDatasets", id: "LIST" }],
    }),

    deleteImagesDataset: builder.mutation({
      query: ({ project_id, images }) => ({
        url: `/label/image/`,
        method: "delete",
        data: { project_id, images },
      }),
      invalidatesTags: [{ type: "ImageDatasets", id: "LIST" }],
    }),

    createAnnotate: builder.mutation({
      query: ({ ...data }) => ({
        url: `/label/image/annotate/`,
        method: "post",
        data: { ...data },
      }),
      invalidatesTags: [{ type: "ImageDatasets", id: "LIST" }],
    }),

    initiateModelTraining: builder.mutation({
      query: ({ ...values }) => ({
        url: `/label/model/train/`,
        method: "post",
        data: { ...values },
      }),
    }),

    modelPrediction: builder.mutation({
      query: ({ ...values }) => ({
        url: `/label/model/predict/`,
        method: "post",
        data: { ...values },
      }),
      invalidatesTags: [{ type: "ImageDatasets", id: "LIST" }],
    }),

    importZipFile: builder.mutation({
      query: ({ formdata }) => ({
        url: `/label/images/import/`,
        method: "post",
        data: formdata,
      }),
    }),

    getZipFiles: builder.query({
      query: ({ project_id }) => ({
        url: `/label/images/export/`,
        params: { project_id },
      }),
    }),

    createExportProject: builder.query({
      query: ({ project_id }) => ({
        url: `/label/images/export/`,
        params: { project_id },
      }),
    }),

    patchStateJson: builder.mutation({
      query: ({ project_id, ...values }) => ({
        url: `/label/state/${project_id}/`,
        method: "post",
        data: { ...values },
      }),
    }),

    getStateJson: builder.query({
      query: ({ project_id }) => ({
        url: `/label/state/${project_id}/`,
      }),
    }),

    createAugmentation: builder.mutation({
      query: ({ ...values }) => ({
        url: `/label/images/augment/`,
        method: "post",
        data: { ...values },
      }),
    }),

     getStudioBackgroundProcess: builder.query({
      query: ({ ...values }) => ({
        url: `/engine/studio-processing/${values?.project_id}`,
      }),
    }),
  }),
});

export const {
  useGetZipFilesQuery,
  useGetStateJsonQuery,
  usePatchStateJsonMutation,
  useLazyGetZipFilesQuery,
  useGetImageDatasetQuery,
  useImportZipFileMutation,
  useGetImagesDatasetQuery,
  useCreateAnnotateMutation,
  useModelPredictionMutation,
  useDeleteImagesDatasetMutation,
  useCreateImagesDatasetMutation,
  useLazyCreateExportProjectQuery,
  useCreateAugmentationMutation,
  useInitiateModelTrainingMutation,
  useGetTrainingModelsQuery,
  useGetStudioBackgroundProcessQuery,
  useLazyGetStudioBackgroundProcessQuery,
} = labelCraftServiceApi;

export const selectImageDatasets =
  labelCraftServiceApi.endpoints?.getImagesDataset?.select;

export const selectAllImageDatasets = createSelector(
  selectImageDatasets(),
  (result) => result?.data
);
